module.exports = bootstrap_app;


//////////////////
// WEBPACK FOOTER
// external "bootstrap_app"
// module id = 420
// module chunks = 6